import { Tag } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/wix-i18n-config';
import classNames from 'classnames';
import {
  FC,
  KeyboardEvent,
  MouseEvent as ReactMouseEvent,
} from 'react';

import { useStore } from '../../../../../zustand/stores';

import css from './index.module.scss';

export type SiteSelectorButtonProps = {
  onOpenPicker: () => void;
};

export const SiteSelectorButton: FC<SiteSelectorButtonProps> = ({
  onOpenPicker,
}) => {
  const { t } = useTranslation();
  const { selectedSite, setUserSelectedSite } = useStore(
    (state) => state.siteSelectorSlice
  );
  const siteName =
    selectedSite?.siteProperties?.siteDisplayName ?? selectedSite?.name ?? '';

  const handleWrapperClick = (e: ReactMouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onOpenPicker();
  };

  const handleWrapperKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onOpenPicker();
    }
  };

  return (
    <div
      className={css.root}
      onClick={handleWrapperClick}
      onKeyDown={handleWrapperKeyDown}
      role="button"
      tabIndex={0}
    >
      <Tag
        id="site-context"
        size="small"
        maxWidth="none"
        className={classNames({ [css.tagUnselected]: !selectedSite })}
        removable={Boolean(selectedSite)}
        onRemove={() => setUserSelectedSite(null)}
      >
        {selectedSite ? (
          <Trans
            i18nKey="site-selector.selected"
            values={{ siteName }}
            components={{ b: <b /> }}
          />
        ) : (
          t('site-selector.not-selected')
        )}
      </Tag>
    </div>
  );
};
